import { FieldConfig } from "pages/Componets/ItemMaster/model/FieldConfig";

export const productHeaderFields: FieldConfig[] = [
    { name: "styleNumber", label: "Style Number", type: "select", required: false, options: [] },
    { name: "materialType", label: "Material Type", type: "select", required: false, options: [] },
    { name: "karat", label: "Karat", type: "select", required: false, options: [] },
    { name: "metalColor", label: "Metal Color", type: "select", required: false, options: [] },
    { name: "category", label: "Category", type: "select", required: false, options: [] },
    { name: "subCategory", label: "SubCategory", type: "select", required: false, options: [] },
];

export const poCreationFields: FieldConfig[] = [
    { name: "vendorId", label: "Vendor", type: "select", required: true, options: [] },
    { name: "quntity", label: "Quantity", type: "number", required: true, },
    { name: "quntity", label: "Quantity", type: "number", required: true, },
    // { name: "poDate", label: "PO Date", type: "date", required: true, },
    // { name: "standardGoldWeight", label: "Standard Gold Wt", type: "decimal", required: true, },
    // { name: "standardDiamondWeight", label: "Standard Diamond Wt", type: "decimal", required: true, },
    { name: "expectedGoldRate", label: "Expected Gold Rate", type: "decimal2", required: true, },
    { name: "expectedDiamondRate", label: "Expected Diamond Rate", type: "decimal2", required: true, },
    { name: "expectedMakingRate", label: "Expected Making Rate", type: "decimal2", required: true, },
    { name: "specialInstructions", label: "Special Instructions", type: "text", required: false, pattern: /^[A-Za-z]+(?: [A-Za-z]+)*$/ },
];

/* 
 type: "text" | "select" | "decimal" | 'number' | 'decimal2' | "checkbox";
    { name: "netWeight", label: "Net Wt", type: 'decimal2', required: true },
    { name: "stoneType", label: "Stone Type", type: "text", required: false, pattern: /^[A-Za-z]+(?: [A-Za-z]+)*$/ },
    { name: "makingType", label: "Making Type", type: "text", required: true, pattern: /^[A-Za-z]+(?: [A-Za-z]+)*$/ },
    { name: "collorStoneWeight", label: "Color Stone Wt", type: 'decimal2', required: false },
*/